import { render, staticRenderFns } from "./DragonballLayout.vue?vue&type=template&id=800c8758&"
import script from "./DragonballLayout.vue?vue&type=script&lang=js&"
export * from "./DragonballLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports